document.addEventListener('alpine:init', () => {
  const gridTransitionOwners = new WeakMap();
  // Scrollable filter columns: the desktop aside pane and the mobile drawer body.
  // Both are (re)built on every filter render, which resets their scrollTop.
  const FILTER_SCROLL_SELECTORS = ['.form-aside .type-aside', '.eurus-filter-block'];
  // The parts of the page a filter change rewrites outside the grid section. Keep these
  // hooks present even with empty content, or a later filter has nothing to swap into.
  const SEO_ROOT_SELECTORS = [
    '[data-breadcrumbs-root]',
    '[data-collection-description-root]',
    '[data-collection-filter-seo-content-root]',
    '[data-collection-filter-seo-faq-root]'
  ];
  // One Intl.NumberFormat per locale; formatPrice runs on every slider input.
  const priceFormatters = {};

  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: false,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    renderVersion: 0,
    renderController: null,
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    // Filter values are real <a href> links so crawlers (and the shopper's context menu)
    // see them. Only a plain left-click is intercepted for the in-place render - Cmd/Ctrl/
    // Shift/Alt clicks and middle-clicks fall through so "open in new tab" still works.
    //
    // An intercepted click ticks the row's own checkbox and goes through the debounced
    // onSubmit() rather than navigating to the href, so ticking several values in a row
    // still collapses into one render the way it did when the row was a <label>. Following
    // the href instead cannot batch: every href is built server-side from the state at
    // render time, so a second click within the debounce window would drop the first value.
    applyFilterUrl(event, link) {
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

      // Nothing may call preventDefault until the row's checkbox is in hand: cancelling the
      // click and then failing leaves a link that looks clickable and does nothing at all.
      // Letting the browser follow the href is the correct fallback: same filter, just a full
      // page load.
      const checkbox = link.closest('li')?.querySelector('input[type="checkbox"]:not([disabled])');
      if (!checkbox) return;

      event.preventDefault();
      // Assigning .checked fires no change event, so onSubmit is called explicitly.
      checkbox.checked = !checkbox.checked;
      this.onSubmit();
    },
    renderPagination() {
      const paginationValue = this.$el.value;

      // Update UI immediately - don't wait for cart update
      this.cachedResults = [];
      const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
      this._renderPage(searchParams);

      // Save to cart attributes in background (non-blocking)
      fetch(Shopify.routes.root + 'cart/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'collection-pagination': paginationValue } })
      }).catch(() => {}); // Silent fail - UI already updated
    },
    // The theme-owned Colored Sapphire checkbox mirrors its checked state onto
    // the member colour checkboxes (data-filter-groups). Those stay visible and
    // individually selectable - it is an additive row, not a consolidating one.
    _syncFilterGroup(controller) {
      const scope = controller.closest('.js-filter');
      if (!scope) return;
      const group = controller.dataset.filterGroup;
      scope.querySelectorAll('input[data-filter-groups]').forEach((input) => {
        if (input.dataset.filterGroups !== group) return;
        input.checked = controller.checked;
      });
    },
    toggleFilterGroup(controller) {
      this._syncFilterGroup(controller);
      this.onSubmit();
    },
    removeFilterGroup(group) {
      const form = document.getElementById('FacetFiltersForm');
      if (!form) return;
      const controller = form.querySelector(`input[data-filter-group="${group}"]`);
      if (!controller) return;
      controller.checked = false;
      this._syncFilterGroup(controller);
      this.onSubmit(0);
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter').blur();
      }
      
      this.t = setTimeout(() => {
        this.t = '';
        func();
      }, wait);
    },
    // A shopper grabbing a price thumb while an earlier filter is still pending
    // or loading would have the filter markup swapped out under the pointer.
    // Drop that render; releasing the thumb submits the whole form again.
    holdRender() {
      if (!this.t && !this.loading) return false;
      clearTimeout(this.t);
      this.t = '';
      this.renderController?.abort();
      this.renderController = null;
      this.renderVersion++;
      return true;
    },
    // Swaps a typed range that runs backwards (From above To) instead of
    // submitting it, which would return no products.
    submitPriceRange(el) {
      const price = Alpine.$data(el);
      if (price.minPrice !== '' && price.maxPrice !== '' && Number(price.minPrice) > Number(price.maxPrice)) {
        [price.minPrice, price.maxPrice] = [price.maxPrice, price.minPrice];
      }
      this.onSubmit(0);
    },
    formatPrice(value, locale) {
      const number = Number(value);
      if (value === '' || value === null || !Number.isFinite(number)) return value;
      priceFormatters[locale] ??= new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });
      return priceFormatters[locale].format(number);
    },
    // The From/To fields drop the grouping while focused (1234.5, or 1234,5 in
    // de-DE) and parsePriceField reads either form back into a number.
    editablePrice(value, locale) {
      return locale === 'de-DE' ? String(value).replace('.', ',') : String(value);
    },
    // Empty stays '' so the bound hidden input is disabled (no URL param).
    parsePriceField(text, locale) {
      const decimal = locale === 'de-DE' ? ',' : '.';
      let digits = '';
      for (const char of String(text)) {
        if (char >= '0' && char <= '9') digits += char;
        else if (char === decimal && !digits.includes('.')) digits += '.';
      }
      return digits === '' || digits === '.' ? '' : Number(digits);
    },
    _reloadFilter(url) {
      // A URL-driven render supersedes anything the debounce still has queued, otherwise
      // that timer fires afterwards and pays for a second identical render.
      clearTimeout(this.t);
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(this._normalizeSearchParams(searchParams));
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return this._normalizeSearchParams(new URLSearchParams(formData).toString(), form);
    },
    _normalizeSearchParams(searchParams, form = document.getElementById('FacetFiltersForm')) {
      const params = new URLSearchParams(searchParams);
      const sortControl = Array.from(form?.elements || []).find((control) => control.name === 'sort_by' && !control.disabled);
      const sortBy = params.get('sort_by');
      if (sortBy === 'most-relevant' || (sortControl?.dataset.defaultSort && sortBy === sortControl.dataset.defaultSort)) {
        params.delete('sort_by');
      }
      // URLSearchParams writes a space as "+", which Shopify's default robots.txt blocks
      // (Disallow: /collections/*+*). A literal plus is already encoded as %2B, so swapping
      // bare "+" for "%20" is lossless and keeps the address bar equal to the canonical.
      return params.toString().replace(/\+/g, '%20');
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    async _renderPage(searchParams, updateURLHash = true) {
      const renderVersion = ++this.renderVersion;
      this.renderController?.abort();
      this.renderController = null;
      this.searchParamsPrev = searchParams;
      this.loading = true;
      if (updateURLHash) this._updateURLHash(searchParams);
      
      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams], renderVersion);
        return;
      }

      // One request for the grid and the SEO sections around it, capped at the five sections
      // the Section Rendering API serves. _renderSeoSections skips any that did not fit.
      const sectionIds = [...new Set([sectionId, ...this._seoRoots().map((root) => root.id)])].slice(0, 5);
      const url = `${window.location.pathname}?sections=${sectionIds.join(',')}&${searchParams}`;

      const controller = new AbortController();
      this.renderController = controller;

      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(`Failed to load filters: ${response.status}`);

        const sections = await response.json();
        if (controller.signal.aborted) return;
        if (typeof sections?.[sectionId] !== 'string') throw new Error('Filter section did not render');

        // A section that failed to render comes back null inside a 200: show what did render,
        // but don't keep it, so returning to this filter tries again.
        if (sectionIds.every((id) => typeof sections[id] === 'string')) this.cachedResults[searchParams] = sections;
        this._renderResults(sections, renderVersion);
      } catch (error) {
        if (error.name !== 'AbortError' && renderVersion === this.renderVersion) {
          this.loading = false;
        }
      } finally {
        if (this.renderController === controller) this.renderController = null;
      }
    },
    // Filtering swaps the whole filter markup, which would reset every accordion to
    // the section's `expand_filter` default. Carry the open ones over so a filter the
    // shopper opened never closes on its own.
    _collectOpenFilters() {
      const open = new Set();
      document.querySelectorAll('.js-filter[data-index]').forEach((el) => {
        const panel = el.querySelector('.collapse-grid');
        if (panel && panel.dataset.open === 'true') open.add(el.dataset.index);
      });
      return open;
    },
    _restoreOpenFilters(parsedHTML, open) {
      if (!open.size) return;
      parsedHTML.querySelectorAll('.js-filter[data-index]').forEach((el) => {
        if (open.has(el.dataset.index)) el.setAttribute('x-data', '{open: true}');
      });
    },
    // The filter column scrolls inside its own pane, so rebuilding it would send the
    // shopper back to the first filter. Keep the pane exactly where it was.
    _collectFilterScroll() {
      const tops = new Map();
      FILTER_SCROLL_SELECTORS.forEach((selector) => {
        const el = document.querySelector(selector);
        if (el && el.scrollTop) tops.set(selector, el.scrollTop);
      });
      return tops;
    },
    _restoreFilterScroll(tops) {
      tops.forEach((top, selector) => {
        const el = document.querySelector(selector);
        if (el) el.scrollTop = top;
      });
    },
    _renderResults(sections, renderVersion) {
      if (renderVersion !== this.renderVersion) return;
      // Parse HTML once and reuse - performance optimization
      const parsedHTML = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      this._renderSeoState(parsedHTML);
      this._restoreOpenFilters(parsedHTML, this._collectOpenFilters());
      const filterScroll = this._collectFilterScroll();
      // Swapping the filter markup drops keyboard focus to the body; return it to
      // the control with the same id (e.g. the price slider after Enter).
      const focused = document.activeElement;
      const focusedId = focused && focused.id && focused.closest('.form-aside, .eurus-filter-block') ? focused.id : '';
      // Refresh aside/above filters so counts update correctly
      try { this._renderFilters(parsedHTML); } catch(e) {}
      // Keep drawer hotfix for mobile
      this._replaceFilters(parsedHTML);
      // The drawer replacement also replaces its active-filter container.
      // Refresh chips last so selections from every filter survive the swap.
      this._renderActiveFacets(parsedHTML);
      this._restoreFilterScroll(filterScroll);
      // A frame later: x-cloak keeps the new panel unfocusable until Alpine's
      // microtask removes it.
      if (focusedId) requestAnimationFrame(() => {
        if (document.activeElement === document.body) document.getElementById(focusedId)?.focus({ preventScroll: true });
      });
      this._renderProductGridContainer(parsedHTML, renderVersion);
      this._renderProductCount(parsedHTML);
      this.loading = false;
      this._renderSeoSections(sections);
    },
    _renderSeoState(parsedHTML) {
      const state = parsedHTML.querySelector('[data-collection-filter-seo-state]');
      if (!state) return;

      const title = state.dataset.title || '';
      const heading = state.dataset.heading || '';
      const description = state.dataset.description || '';
      const canonical = state.dataset.canonical || '';
      const robots = state.dataset.robots || '';

      if (title) document.title = title;

      const headingElement = document.querySelector('[data-collection-filter-seo-heading]');
      if (headingElement && heading) headingElement.textContent = heading;

      let descriptionElement = document.querySelector('meta[name="description"]');
      if (description) {
        if (!descriptionElement) {
          descriptionElement = document.createElement('meta');
          descriptionElement.name = 'description';
          document.head.appendChild(descriptionElement);
        }
        descriptionElement.content = description;
      } else if (descriptionElement) {
        descriptionElement.remove();
      }

      const canonicalElement = document.querySelector('link[rel="canonical"]');
      if (canonicalElement && canonical) canonicalElement.href = canonical;

      const robotsElement = document.querySelector('meta[name="robots"]');
      if (robotsElement && robots) robotsElement.content = robots;
    },
    // The SEO hooks outside the grid section. The state template ships with the grid, so
    // pages without it (search) have none to refresh.
    _seoRoots() {
      if (!document.querySelector('[data-collection-filter-seo-state]')) return [];
      return SEO_ROOT_SELECTORS.flatMap((selector) =>
        Array.from(document.querySelectorAll(selector)).map((target) => ({
          selector,
          target,
          id: target.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '')
        }))
      ).filter((root) => root.id);
    },
    _renderSeoSections(sections) {
      const parsedSections = new Map();
      this._seoRoots().forEach(({ selector, target, id }) => {
        if (typeof sections[id] !== 'string') return;
        if (!parsedSections.has(id)) parsedSections.set(id, new DOMParser().parseFromString(sections[id], 'text/html'));
        const source = parsedSections.get(id).querySelector(selector);
        // Like the product grid, Alpine's mutation observer cleans up what leaves and
        // initializes what arrives.
        if (source) target.innerHTML = source.innerHTML;
      });
    },
    _renderFilters(parsedHTML) {
      // Replace entire aside form to avoid partial duplication states
      try {
        const aside = document.querySelector('.form-aside');
        const asideSrc = parsedHTML.querySelector('.form-aside');
        if (aside && asideSrc) {
          aside.innerHTML = asideSrc.innerHTML;
          if (window.Alpine && typeof window.Alpine.initTree === 'function') {
            window.Alpine.initTree(aside);
          }
        }
      } catch(e) {}

      this._renderAdditionalElements(parsedHTML);
      // Drawer content is handled by _replaceFilters
    },
    /* Hotfix filter render incorrect */
    _replaceFilters(parsedHTML) {
      const blockFiltes = document.querySelector('.eurus-filter-block');
      if (blockFiltes) {
        if (this.$el.id && parsedHTML.getElementById(this.$el.id)) {
          const eleOpening = parsedHTML.getElementById(this.$el.id).closest('.js-filter');
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        const src = parsedHTML.querySelector('.eurus-filter-block');
        if (src) {
          blockFiltes.innerHTML = src.innerHTML;
          if (window.Alpine && typeof window.Alpine.initTree === 'function') {
            window.Alpine.initTree(blockFiltes);
          }
        } else {
        }
      };
    },
    _renderProductGridContainer(parsedHTML, renderVersion) {
      const source = parsedHTML.getElementById('ProductGridContainer');
      const target = document.getElementById('ProductGridContainer');
      if (!source || !target) return;
      const supportsTypedViewTransitions =
        typeof CSS !== 'undefined' &&
        typeof CSS.supports === 'function' &&
        CSS.supports('selector(:active-view-transition-type(grid-cards))');
      const transitionOwner = {};
      const applyGrid = () => {
        if (renderVersion !== this.renderVersion) return false;
        target.innerHTML = source.innerHTML;
        document.dispatchEvent(new CustomEvent('eurus:product-grid:updated'));
        return true;
      };
      // Missing or partial View Transitions support / reduced-motion: swap instantly.
      if (
        typeof document.startViewTransition !== 'function' ||
        !supportsTypedViewTransitions ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        applyGrid();
        return;
      }
      // Mobile: swap instantly. View Transition snapshots render above the filter drawer.
      if (!window.matchMedia('(min-width: 1024px)').matches) {
        applyGrid();
        return;
      }

      // --- Desktop: per-card morph (surviving cards glide to their new positions) ---
      const handleOf = (el) => {
        const a = el.matches('a[href*="/products/"]') ? el : el.querySelector('a[href*="/products/"]');
        if (!a) return null;
        const m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
        return m ? m[1] : null;
      };
      const inViewport = (el) => {
        const r = el.getBoundingClientRect();
        if (r.width <= 0 || r.height <= 0) return false;
        return r.bottom > 0 && r.top < window.innerHeight;
      };
      const clearTags = (els) => {
        for (let i = 0; i < els.length; i++) {
          if (gridTransitionOwners.get(els[i]) !== transitionOwner) continue;
          gridTransitionOwners.delete(els[i]);
          els[i].style.viewTransitionName = '';
          els[i].style.viewTransitionClass = '';
        }
      };
      const tagCard = (card, name) => {
        gridTransitionOwners.set(card, transitionOwner);
        card.style.viewTransitionName = name;
        card.style.viewTransitionClass = 'leibish-card';
      };
      const startTransition = (update, type) => {
        return document.startViewTransition({ update, types: [type] });
      };

      // Tag the current (old) cards that are in view, capped at 16, de-duped by handle.
      const oldTagged = [];
      const oldCandidates = [];
      const oldNames = new Set();
      const oldCards = target.querySelectorAll('.grid-item, .grid__item');
      for (const card of oldCards) {
        if (oldCandidates.length >= 16) break;
        if (!inViewport(card)) continue;
        const h = handleOf(card);
        if (!h) continue;
        const name = 'c-' + h;
        if (oldNames.has(name)) continue;
        oldNames.add(name);
        oldCandidates.push({ card, name });
      }

      // Finish every layout read before writing transition styles.
      for (const { card, name } of oldCandidates) {
        tagCard(card, name);
        oldTagged.push(card);
      }

      // Nothing to morph individually -> fall back to the whole-grid fade.
      if (oldTagged.length === 0) {
        try {
          startTransition(applyGrid, 'grid-fade').finished.catch(() => {});
        } catch(e) {
          applyGrid();
        }
        return;
      }

      const newTagged = [];
      const update = () => {
        if (!applyGrid()) return;
        // Re-tag only NEW cards whose name survived the swap, so leavers/enterers fall back to the grid fade.
        const newCards = target.querySelectorAll('.grid-item, .grid__item');
        const seen = new Set();
        for (let i = 0; i < newCards.length; i++) {
          const card = newCards[i];
          const h = handleOf(card);
          if (!h) continue;
          const name = 'c-' + h;
          if (!oldNames.has(name) || seen.has(name)) continue;
          seen.add(name);
          tagCard(card, name);
          newTagged.push(card);
        }
      };

      const cleanup = () => { clearTags(oldTagged); clearTags(newTagged); };

      try {
        const transition = startTransition(update, 'grid-cards');
        // Handle both outcomes so a cancelled transition cannot leave stale names.
        transition.finished.then(cleanup, cleanup);
      } catch(e) {
        // Total fallback: never leave stale view-transition-name on the live DOM.
        clearTags(oldTagged);
        applyGrid();
      }
    },
    _renderProductCount(parsedHTML) {
      const productCountEl = parsedHTML.getElementById('ProductCount');
      if (productCountEl) {
        let countMarkup = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) {
          container.innerHTML = countMarkup;
          container.classList.remove('loading');
        }
        if (containerDrawer) {
          containerDrawer.innerHTML = countMarkup;
          containerDrawer.classList.remove('loading');
        }
        document.querySelectorAll('#ProductCount').forEach((el) => {
          el.innerHTML = countMarkup;
          el.classList.remove('loading');
        });
      }
    },
    _renderActiveFacets(html) {
      const filterTag = document.getElementById('active-filter-tag');
      const filterTagMobile = document.getElementById('active-filter-tag-mobile');
      const filterTagSource = html.getElementById('active-filter-tag');
      const filterTagMobileSource = html.getElementById('active-filter-tag-mobile');
      if (filterTag && filterTagSource) filterTag.innerHTML = filterTagSource.innerHTML;
      if (filterTagMobile && filterTagMobileSource) filterTagMobile.innerHTML = filterTagMobileSource.innerHTML;
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
    },
    _renderCounts(source, target) {
      const targetElement = target.querySelector('.facets__selected');
      const sourceElement = source.querySelector('.facets__selected');
  
      const targetElementAccessibility = target.querySelector('.facets__summary');
      const sourceElementAccessibility = source.querySelector('.facets__summary');
  
      if (sourceElement && targetElement) {
        target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
      }
  
      if (targetElementAccessibility && sourceElementAccessibility) {
        target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
      }
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - 320;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    }
  }));

  // The price_range filter (snippets/filter-price-range.liquid). minPrice and
  // maxPrice are the source of truth, x-model-bound to the From/To fields and the
  // submitted inputs; the two range inputs only move through `stops` (round
  // prices rendered by the snippet) and follow the prices through minStop/maxStop.
  // Methods run with the merged Alpine scope, so `this` also reaches
  // xFiltersAndSortby (onSubmit, holdRender).
  Alpine.data('xPriceRange', ({ minPrice, maxPrice, rangeMax, locale, stops }) => ({
    minPrice,
    maxPrice,
    rangeMax,
    locale,
    stops,
    grabbed: false,
    // The From thumb rounds down to a stop and the To thumb up, so a typed price
    // stays inside the band the thumbs show (the snippet places them the same way).
    stopIndex(price, roundUp) {
      const last = this.stops.length - 1;
      const value = Number(price);
      if (price === '' || price === null || !Number.isFinite(value)) return roundUp ? last : 0;
      if (roundUp) {
        const index = this.stops.findIndex((stop) => stop >= value);
        return index === -1 ? last : index;
      }
      return Math.max(this.stops.findLastIndex((stop) => stop <= value), 0);
    },
    get minStop() {
      return this.stopIndex(this.minPrice, false);
    },
    get maxStop() {
      return this.stopIndex(this.maxPrice, true);
    },
    get fillStyle() {
      const last = this.stops.length - 1;
      const start = Math.min(this.minStop, this.maxStop) / last;
      const end = Math.max(this.minStop, this.maxStop) / last;
      return `--price-min: ${start}; --price-max: ${end};`;
    },
    _setStop(bound, stop) {
      const last = this.stops.length - 1;
      if (bound === 'min') {
        stop = Math.max(Math.min(stop, this.maxStop - 1), 0);
        this.minPrice = this.stops[stop];
      } else {
        stop = Math.min(Math.max(stop, this.minStop + 1), last);
        this.maxPrice = this.stops[stop];
      }
      return stop;
    },
    slide(event, bound) {
      // A clamp can leave the price unchanged, which re-runs no :value binding,
      // so the handle is put back explicitly.
      event.target.value = this._setStop(bound, Number(event.target.value));
    },
    // Dragging applies on release, like the checkbox filters; the keyboard keeps
    // Enter/Apply, so arrowing through stops does not re-render on every press.
    grab(event) {
      this.grabbed = event.target.type === 'range';
      if (!this.grabbed || event.button > 0) return;
      const held = this.holdRender();
      const start = `${this.minPrice}|${this.maxPrice}`;
      const listeners = new AbortController();
      const release = () => {
        listeners.abort();
        if (held || start !== `${this.minPrice}|${this.maxPrice}`) this.onSubmit(0);
      };
      window.addEventListener('pointerup', release, { signal: listeners.signal });
      window.addEventListener('pointercancel', release, { signal: listeners.signal });
    },
    // A click on the rail (the range inputs only take pointer events on their
    // thumbs) moves the nearer thumb to that stop and applies it.
    jump(event) {
      if (this.grabbed) {
        this.grabbed = false;
        return;
      }
      if (event.target.type === 'range') return;
      const track = event.currentTarget;
      const rect = track.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const thumb = parseFloat(styles.getPropertyValue('--price-thumb')) || 0;
      const offset = styles.direction === 'rtl' ? rect.right - event.clientX : event.clientX - rect.left;
      const ratio = Math.min(Math.max((offset - thumb / 2) / (rect.width - thumb), 0), 1);
      const stop = Math.round(ratio * (this.stops.length - 1));
      const bound = stop < this.minStop || (stop <= this.maxStop && stop - this.minStop < this.maxStop - stop) ? 'min' : 'max';
      this._setStop(bound, stop);
      this.onSubmit(0);
    },
  }));
});
